import { isToolbarOembedActive } from './ToolbarStore';

export const updateToolbarOembed = (value) => isToolbarOembedActive.update((oldValue) => value);
